// Mock Installment Data - İNSAET
// Taksit takibi verileri

export const mockInstallments = [
    // ==================== YEŞİL PARK - TAKSİTLİ SATIŞLAR ====================
    // A-2 Dairesi - Sevgi Korkmaz (12 taksit)
    {
        id: 'inst1',
        constructionId: 'c1',
        apartmentId: 'a2',
        apartmentNo: 'A-2',
        personId: 'ind-2',
        personName: 'Sevgi Korkmaz',
        totalAmount: 1850000,
        downPayment: 500000,
        financedAmount: 1350000,
        installmentCount: 12,
        startDate: '2026-03-01',
        payments: [
            { no: 1, dueDate: '2026-03-01', amount: 112500, status: 'paid', paidDate: '2026-03-01', paidAmount: 112500 },
            { no: 2, dueDate: '2026-04-01', amount: 112500, status: 'paid', paidDate: '2026-04-01', paidAmount: 112500 },
            { no: 3, dueDate: '2026-05-01', amount: 112500, status: 'paid', paidDate: '2025-05-03', paidAmount: 112500 },
            { no: 4, dueDate: '2025-06-01', amount: 112500, status: 'paid', paidDate: '2025-06-01', paidAmount: 112500 },
            { no: 5, dueDate: '2025-07-01', amount: 112500, status: 'paid', paidDate: '2025-07-02', paidAmount: 112500 },
            { no: 6, dueDate: '2025-08-01', amount: 112500, status: 'paid', paidDate: '2025-08-01', paidAmount: 112500 },
            { no: 7, dueDate: '2025-09-01', amount: 112500, status: 'paid', paidDate: '2025-09-01', paidAmount: 112500 },
            { no: 8, dueDate: '2025-10-01', amount: 112500, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 9, dueDate: '2025-11-01', amount: 112500, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 10, dueDate: '2025-12-01', amount: 112500, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 11, dueDate: '2026-01-01', amount: 112500, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 12, dueDate: '2026-02-01', amount: 112500, status: 'pending', paidDate: null, paidAmount: 0 },
        ],
        paidTotal: 787500,
        remainingTotal: 562500,
        status: 'active',
        notes: 'Düzenli ödemeler yapılıyor.',
        createdAt: '2026-03-01T10:00:00Z',
        updatedAt: '2025-09-01T11:00:00Z',
    },

    // A-5 Dairesi - Elif Tuncer (18 taksit)
    {
        id: 'inst2',
        constructionId: 'c1',
        apartmentId: 'a5',
        apartmentNo: 'A-5',
        personId: 'ind-6',
        personName: 'Elif Tuncer',
        totalAmount: 3200000,
        downPayment: 1000000,
        financedAmount: 2200000,
        installmentCount: 18,
        startDate: '2025-08-01',
        payments: [
            { no: 1, dueDate: '2025-08-01', amount: 122222, status: 'paid', paidDate: '2025-08-01', paidAmount: 122222 },
            { no: 2, dueDate: '2025-09-01', amount: 122222, status: 'paid', paidDate: '2025-09-02', paidAmount: 122222 },
            { no: 3, dueDate: '2025-10-01', amount: 122222, status: 'paid', paidDate: '2025-10-15', paidAmount: 122222 },
            { no: 4, dueDate: '2025-11-01', amount: 122222, status: 'overdue', paidDate: null, paidAmount: 0 },
            { no: 5, dueDate: '2025-12-01', amount: 122222, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 6, dueDate: '2026-01-01', amount: 122222, status: 'pending', paidDate: null, paidAmount: 0 },
        ],
        paidTotal: 366666,
        remainingTotal: 1833334,
        status: 'active',
        notes: 'Kasım taksiti gecikmiş.',
        createdAt: '2025-08-01T10:00:00Z',
        updatedAt: '2025-10-15T12:00:00Z',
    },

    // B-2 Dairesi - Melis Aydoğan (10 taksit)
    {
        id: 'inst3',
        constructionId: 'c1',
        apartmentId: 'a10',
        apartmentNo: 'B-2',
        personId: 'ind-8',
        personName: 'Melis Aydoğan',
        totalAmount: 2250000,
        downPayment: 800000,
        financedAmount: 1450000,
        installmentCount: 10,
        startDate: '2025-07-01',
        payments: [
            { no: 1, dueDate: '2025-07-01', amount: 145000, status: 'paid', paidDate: '2025-07-01', paidAmount: 145000 },
            { no: 2, dueDate: '2025-08-01', amount: 145000, status: 'paid', paidDate: '2025-08-01', paidAmount: 145000 },
            { no: 3, dueDate: '2025-09-01', amount: 145000, status: 'paid', paidDate: '2025-09-01', paidAmount: 145000 },
            { no: 4, dueDate: '2025-10-01', amount: 145000, status: 'paid', paidDate: '2025-10-05', paidAmount: 145000 },
            { no: 5, dueDate: '2025-11-01', amount: 145000, status: 'paid', paidDate: '2025-11-01', paidAmount: 145000 },
            { no: 6, dueDate: '2025-12-01', amount: 145000, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 7, dueDate: '2026-01-01', amount: 145000, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 8, dueDate: '2026-02-01', amount: 145000, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 9, dueDate: '2026-03-01', amount: 145000, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 10, dueDate: '2026-04-01', amount: 145000, status: 'pending', paidDate: null, paidAmount: 0 },
        ],
        paidTotal: 725000,
        remainingTotal: 725000,
        status: 'active',
        notes: 'Düzenli ödemeler.',
        createdAt: '2025-07-01T10:00:00Z',
        updatedAt: '2025-11-01T14:00:00Z',
    },

    // ==================== MAVİ DENİZ - TAKSİTLİ SATIŞLAR ====================
    // A-2 Dairesi - Derya Güneş (6 taksit)
    {
        id: 'inst4',
        constructionId: 'c2',
        apartmentId: 'a18',
        apartmentNo: 'A-2',
        personId: 'ind-4',
        personName: 'Derya Güneş',
        totalAmount: 3150000,
        downPayment: 2500000,
        financedAmount: 650000,
        installmentCount: 6,
        startDate: '2025-08-01',
        payments: [
            { no: 1, dueDate: '2025-08-01', amount: 108333, status: 'paid', paidDate: '2025-08-01', paidAmount: 108333 },
            { no: 2, dueDate: '2025-09-01', amount: 108333, status: 'paid', paidDate: '2025-09-01', paidAmount: 108333 },
            { no: 3, dueDate: '2025-10-01', amount: 108333, status: 'paid', paidDate: '2025-10-02', paidAmount: 108333 },
            { no: 4, dueDate: '2025-11-01', amount: 108333, status: 'paid', paidDate: '2025-11-10', paidAmount: 108333 },
            { no: 5, dueDate: '2025-12-01', amount: 108334, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 6, dueDate: '2026-01-01', amount: 108334, status: 'pending', paidDate: null, paidAmount: 0 },
        ],
        paidTotal: 433332,
        remainingTotal: 216668,
        status: 'active',
        notes: 'Son 2 taksit kaldı.',
        createdAt: '2025-08-01T10:00:00Z',
        updatedAt: '2025-11-10T11:00:00Z',
    },

    // A-6 Dairesi - Ceren Aksoy (15 taksit)
    {
        id: 'inst5',
        constructionId: 'c2',
        apartmentId: 'a22',
        apartmentNo: 'A-6',
        personId: 'ind-10',
        personName: 'Ceren Aksoy',
        totalAmount: 3750000,
        downPayment: 1500000,
        financedAmount: 2250000,
        installmentCount: 15,
        startDate: '2025-09-01',
        payments: [
            { no: 1, dueDate: '2025-09-01', amount: 150000, status: 'paid', paidDate: '2025-09-01', paidAmount: 150000 },
            { no: 2, dueDate: '2025-10-01', amount: 150000, status: 'paid', paidDate: '2025-10-01', paidAmount: 150000 },
            { no: 3, dueDate: '2025-11-01', amount: 150000, status: 'paid', paidDate: '2025-11-05', paidAmount: 150000 },
            { no: 4, dueDate: '2025-12-01', amount: 150000, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 5, dueDate: '2026-01-01', amount: 150000, status: 'pending', paidDate: null, paidAmount: 0 },
        ],
        paidTotal: 450000,
        remainingTotal: 1800000,
        status: 'active',
        notes: 'Düzenli ödemeler.',
        createdAt: '2025-09-01T10:00:00Z',
        updatedAt: '2025-11-05T14:00:00Z',
    },

    // A-12 Dairesi - Tolga Başaran (8 taksit)
    {
        id: 'inst6',
        constructionId: 'c2',
        apartmentId: 'a28',
        apartmentNo: 'A-12',
        personId: 'ind-11',
        personName: 'Tolga Başaran',
        totalAmount: 5600000,
        downPayment: 4500000,
        financedAmount: 1100000,
        installmentCount: 8,
        startDate: '2025-10-01',
        payments: [
            { no: 1, dueDate: '2025-10-01', amount: 137500, status: 'paid', paidDate: '2025-10-01', paidAmount: 137500 },
            { no: 2, dueDate: '2025-11-01', amount: 137500, status: 'paid', paidDate: '2025-11-20', paidAmount: 137500 },
            { no: 3, dueDate: '2025-12-01', amount: 137500, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 4, dueDate: '2026-01-01', amount: 137500, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 5, dueDate: '2026-02-01', amount: 137500, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 6, dueDate: '2026-03-01', amount: 137500, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 7, dueDate: '2026-04-01', amount: 137500, status: 'pending', paidDate: null, paidAmount: 0 },
            { no: 8, dueDate: '2026-05-01', amount: 137500, status: 'pending', paidDate: null, paidAmount: 0 },
        ],
        paidTotal: 275000,
        remainingTotal: 825000,
        status: 'active',
        notes: 'Penthouse, 6 taksit kaldı.',
        createdAt: '2025-10-01T10:00:00Z',
        updatedAt: '2025-11-20T09:00:00Z',
    },
];

// Helper functions
export const getInstallmentsByConstructionId = (constructionId) => {
    if (!constructionId) return mockInstallments;
    return mockInstallments.filter(inst => inst.constructionId === constructionId);
};

export const getInstallmentsByPersonId = (personId) => {
    return mockInstallments.filter(inst => inst.personId === personId);
};

export const getOverdueInstallments = (constructionId) => {
    const installments = constructionId
        ? mockInstallments.filter(inst => inst.constructionId === constructionId)
        : mockInstallments;

    return installments.filter(inst =>
        inst.payments.some(p => p.status === 'overdue')
    );
};

export const getInstallmentStats = (constructionId) => {
    const installments = constructionId
        ? mockInstallments.filter(inst => inst.constructionId === constructionId)
        : mockInstallments;

    return {
        totalCount: installments.length,
        totalFinanced: installments.reduce((sum, inst) => sum + inst.financedAmount, 0),
        totalPaid: installments.reduce((sum, inst) => sum + inst.paidTotal, 0),
        totalRemaining: installments.reduce((sum, inst) => sum + inst.remainingTotal, 0),
        overdueCount: installments.filter(inst =>
            inst.payments.some(p => p.status === 'overdue')
        ).length,
    };
};

export default mockInstallments;
